module.exports = __webpack_public_path__ + "static/img/ppt-2.11d8e56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt-2.jpg
// module id = QQRK
// module chunks = 1